import React from 'react';

export const BulbIcon = ({ width = 16, height = 16 }) => (
  <svg
    fill="none"
    focusable="false"
    height={height}
    role="presentation"
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      opacity="0.4"
      d="M2.66602 6.66683V6.83919C2.66602 8.00525 3.14866 9.11931 3.99935 9.91683L4.76048 10.6304C5.01435 10.8684 5.19184 11.1721 5.27642 11.5033C5.29489 11.5012 5.31366 11.5002 5.33268 11.5002H7.49935L7.49935 8.40318C7.38216 8.35772 7.26982 8.29834 7.16168 8.22949L6.40239 7.75835C6.16775 7.61276 6.09556 7.30452 6.24116 7.06987C6.38675 6.83523 6.695 6.76305 6.92964 6.90864L7.6971 7.38485C7.84767 7.48103 7.93923 7.50016 7.99935 7.50016C8.05947 7.50016 8.15105 7.48106 8.30162 7.38488L8.30713 7.38136L9.06906 6.90864C9.3037 6.76305 9.61194 6.83523 9.75754 7.06987C9.90313 7.30452 9.83095 7.61276 9.5963 7.75835L8.83701 8.22949C8.72888 8.29834 8.61654 8.35772 8.49935 8.40318V11.5002H10.666C10.685 11.5002 10.7038 11.5012 10.7223 11.5033C10.8069 11.1721 10.9843 10.8684 11.2382 10.6304L11.9993 9.91683C12.85 9.11931 13.3327 8.00525 13.3327 6.83919V6.66683C13.3327 3.72131 10.9449 1.3335 7.99935 1.3335C5.05383 1.3335 2.66602 3.72131 2.66602 6.66683Z"
      fill="#03000A"
    />
    <path
      d="M10.6206 12.5C10.3866 13.7338 9.30259 14.6667 8.00073 14.6667C6.69887 14.6667 5.6149 13.7338 5.38086 12.5H10.6206Z"
      fill="#03000A"
    />
  </svg>
);
